import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { PERIODS } from "@/lib/format";

export function PeriodSelector({ value, onChange }) {
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger
        data-testid="period-selector"
        className="h-10 w-[180px] bg-card"
      >
        <SelectValue placeholder="Período" />
      </SelectTrigger>
      <SelectContent>
        {PERIODS.map((p) => (
          <SelectItem
            key={p.value}
            value={p.value}
            data-testid={`period-option-${p.value}`}
          >
            {p.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
